/* eslint-disable camelcase */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hidePinForm } from 'containers/PinForm/actions/pinForm.actions';

import { Form } from 'cvlib';

const CallCenterModal = () => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;

  const elements = [
    {
      element: 'title',
      content: translate('updateMailCallCenter_modal_title_label'),
      style: { paddingTop: '1.75rem' },
    },
    {
      element: 'message',
      content: translate('updateMailCallCenter_modal_description_label'),
      expand: 3,
      position: 'center',
      style: { padding: '0 2.5rem' },
    },
    {
      element: 'button',
      type: 'red',
      content: translate('updateMailCallCenter_modal_option_button_close'),
      onClick: () => dispatch(hidePinForm()),
      style: { width: '288px' },
      className: 'redButton',
      expand: 5,
    },
  ];

  return <Form elements={elements} classes={['pin-form-call-center-modal']} />;
};

export default CallCenterModal;
